import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { PropertyLedgerCodeModel } from '../models/property-ledger-code.model';

@Injectable({
  providedIn: 'root'
})
export class LedgerCodesService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  public GetLedgerCodes(): Observable<Array<PropertyLedgerCodeModel>> {
    return this.http.get<Array<PropertyLedgerCodeModel>>(this.config.getApiRoute('api/v3/client-portal/ledger-codes')).pipe(
        map(data => {
            return data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        }));
    }
}